export default function Logo({ dark = false }) {
  return (
    <span className="inline-flex items-center">
      <img
        src="/logo.png"
        alt="Global Pastel — Importador de insumos y utensilios de repostería"
        className="h-12 w-12 rounded-full object-cover sm:h-13 sm:w-13"
      />
    </span>
  );
}
